<template>
	<div class="card">
		<div class="card-header">Events</div>
		<div class="card-body">
			<table class="table">
				<tbody>
					<template v-for="event in result.events" >
						<tr v-if="event.eventAction && event.eventDate" :key="event.eventDate">
							<th scope="row" width="120px">{{ event_types[event.eventAction] }}</th>
							<td>{{ event.eventDate | parseDate(0, 10) }} {{ event.eventDate | parseDate(11, 19) }} UTC</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: ['result'],
	data() {
		return {
			event_types: {
				registration: 'Registration',
				reregistration: 'Reregistration',
				'last changed': 'Last Changed',
				expiration: 'Expiration',
				deletion: 'Deletion',
				reinstantiation: 'Reinstantiation',
				transfer: 'Transfer',
				locked: 'Locked',
				unlocked: 'Unlocked'
			}
		};
	},
	filters: {
		parseDate(value, start, end) {
			const date = new Date(Date.parse(value));
			return date.toISOString().slice(start, end);
		}
	}
};
</script>

<style scoped lang="scss">
tbody tr:first-child {
	th,
	td {
		border-top: none;
	}
}
</style>
